export const mapLongIceDateToDisplayDate = (iceDate: string): string => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Yearly format: "2025"
    if (/^\d{4}$/.test(iceDate)) {
        return iceDate;
    }

    // Quarterly format: "2025-Q2"
    if (/^\d{4}-Q\d$/.test(iceDate)) {
        return iceDate;
    }

    // Monthly format: "2025-6" or "2025-12"
    if (/^\d{4}-\d{1,2}$/.test(iceDate)) {
        const [year, month] = iceDate.split('-');
        const monthName = monthNames[parseInt(month, 10) - 1];
        return `${monthName} ${year}`;
    }

    // Long date format: "9/26/2025 12:00:00 AM"
    const datePart = iceDate.split(' ')[0];
    const [month, day] = datePart.split('/');
    const monthName = monthNames[parseInt(month, 10) - 1];

    return `${parseInt(day, 10)} ${monthName}`;
};
